import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PageHeader1 from "../../../components/common/PageHeader1";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

function UserTracking() {
  const token = localStorage.getItem("vedhvidhi-admin-token");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const fetchActivityLogs = async () => {
      if (!token) {
        setRows([]);
        setRowCount(0);
        return;
      }

      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/activity-logs`,
          {
            headers: { Authorization: token },
            params: {
              page: paginationModel.page + 1,
              limit: paginationModel.pageSize,
              ...(debouncedSearchValue
                ? { search: debouncedSearchValue }
                : {}),
            },
          }
        );

        const payload = response?.data || {};
        const logs = payload?.data || payload?.docs || [];
        const totalDocs =
          payload?.paginationDetail?.totalDocs ||
          payload?.totalDocs ||
          payload?.total ||
          logs.length ||
          0;

        const formatted = logs.map((item, index) => ({
          id: item?._id || item?.id || `${paginationModel.page}-${index}`,
          sono: paginationModel.page * paginationModel.pageSize + index + 1,
          user:
            item?.admin?.fullName ||
            item?.admin?.name ||
            item?.fullName ||
            item?.name ||
            item?.userName ||
            item?.user?.fullName ||
            item?.adminName ||
            "N/A",
          role: item?.admin?.role || "N/A",
          email: item?.admin?.email || item?.email || item?.user?.email || "N/A",
          action:
            item?.actionName ||
            item?.action ||
            item?.activity ||
            item?.event ||
            item?.message ||
            "N/A",
          module:
            item?.moduleName || item?.module || item?.resource || item?.feature || "N/A",
          status: item?.status || "N/A",
          recordId: item?.recordId || "-",
          ip:
            item?.ip ||
            item?.ipAddress ||
            item?.ip_address ||
            item?.requestIp ||
            "N/A",
          userAgent: item?.userAgent || "N/A",
          createdAt: item?.timestamp
            ? new Date(item.timestamp).toLocaleString()
            : item?.createdAt
            ? new Date(item.createdAt).toLocaleString()
            : "N/A",
        }));

        setRows(formatted);
        setRowCount(totalDocs);
      } catch (error) {
        setRows([]);
        setRowCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchActivityLogs();
  }, [token, paginationModel.page, paginationModel.pageSize, debouncedSearchValue]);

  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchValue]);

  const columns = useMemo(
    () => [
      { field: "sono", headerName: "S.No", width: 90, sortable: false },
      // { field: "user", headerName: "User", width: 180 },
      { field: "role", headerName: "Role", width: 150 },
      { field: "email", headerName: "Email", width: 220 },
      { field: "action", headerName: "Action Name", width: 180 },
      { field: "module", headerName: "Module Name", width: 170 },
      { field: "status", headerName: "Status", width: 120 },
      // { field: "recordId", headerName: "Record ID", width: 200 },
      { field: "ip", headerName: "IP Address", width: 160 },
      { field: "userAgent", headerName: "User Agent", flex: 1, minWidth: 320 },
      { field: "createdAt", headerName: "Created At", width: 190 },
    ],
    []
  );

  return (
    <div className="body d-flex py-1">
      <div className="container-xxl">
        <PageHeader1 pagetitle="User Tracking" />
        <div className="row g-0 mb-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {/*<Box sx={{ mb: 2, maxWidth: 420 }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Search Logs"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="Search by action, module, email..."
                    InputProps={{
                      endAdornment: searchValue ? (
                        <InputAdornment position="end">
                          <Tooltip title="Clear Search">
                            <IconButton
                              size="small"
                              onClick={() => setSearchValue("")}
                            >
                              <i className="icofont-close-line" />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </Box>*/}
                <Box sx={{ width: 1, height: 560 }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    paginationMode="server"
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10, 25, 50, 100]}
                    disableRowSelectionOnClick
                  />
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserTracking;
